import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from './en.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationEn,
    },
  },
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
